<template>
  <b-modal id="bpjs-ketenagakerjaan-detail" ref="modal" size="lg" title="Detail" @show="setData" @hidden="resetModal">
    <b-form  ref="form">
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Registered Name</label>
                <div class="col-md-8 mb-3">
                  {{detail.name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Number</label>
                <div class="col-md-8 mb-3">
                  {{detail.number}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Date of Issue</label>
                <div class="col-md-8 mb-3">
                  {{detail.valid_from}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Expiration Date</label>
                <div class="col-md-8 mb-3">
                  {{detail.valid_until}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Mother Name</label>
                <div class="col-md-8 mb-3">
                  {{detail.nama_ibu}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                  {{detail.desc}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                  {{detail.status}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Last Modified</label>
                <div class="col-md-8 mb-3">
                  {{detail.last_modified}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BForm, BModal} from 'bootstrap-vue'

export default {
  name: "BpjsKetenagakerjaanDetailForm",
  components:{
    BModal,
    BForm
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
        detail:{
          number:"",
          name:"",
          nama_ibu:"",
          desc:"",
          valid_from:"",
          valid_until:"",
          status:"",
          last_modified:""
        }
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        if (this.data !== null){
          this.detail={
            number: this.data.number,
            name: this.data.name,
            nama_ibu: this.data.nama_ibu,
            desc: this.data.desc,
            valid_from: this.data.valid_from,
            valid_until: this.data.valid_until,
            status: (this.data.status == 1) ? 'Active': 'Not Active',
            last_modified: this.data.last_modified
          }
        }
      }, 100)
    },
    resetModal(){
      this.$parent.data = null
      this.$refs.modal.hide()
    }
  }
}
</script>